export const siteSettings = {
  name: "Toknex",
  link: "https://toknex.org",
  email: "support@toknex.org",
  appLink: "https://app.toknex.org",
};
